import * as React from 'react';
import { useEffect, useState } from 'react';
import Modal from "../../../component/Global/Modal";
import datasheet2 from "src/assets/images/icon-datasheet-2.png"
import DisplayLifeCycleRisk from 'src/component/Product/DisplayLifeCycleRisk';
import DisplayQtyMinQtyMult from 'src/component/Product/DisplayQtyMinQtyMult';
import PriceTable from 'src/component/Global/Cart/PriceTable';
import { useBOMStore } from 'src/hooks/bom';
import { useAxiosIndicatorCheck } from "../../../store/hook/useAxiosIndicatorCheck";
import ProductListing from "../../../model/ProductListing";
import ProductInventoryRepository from "../../../repository/ProductInventoryRepository";
import ProductPricingRepository from "../../../repository/ProductPricingRepository";
import $ from "jquery";
import "floating-scroll";
import { useProductStore } from 'src/hooks/product';
import CustomerPartNumberOptions from 'src/component/Global/Cart/CustomerPartNumberOptions';
import noImage from 'src/assets/images/noimage.png'
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import ReusableDiv from 'src/support/ReusableDiv';
import { useCartStore } from 'src/hooks/cart';
import Constants from 'src/support/Constants';
import AxiosIndicatorRunTimeLoader from 'src/component/AxiosIndicatorRunTimeLoader';
import Helper from "src/support/Helper";
import liveAuth from 'src/helper/liveAuth';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';
import ProductInventoryDisplay from "../../../component/Global/Product/ProductInventoryDisplay";
import { useProductInventoryStore } from "../../../hooks/productInventory";
import { useProductPricingStore } from 'src/hooks/productPricing';

const AlternativeBomPopup = (props) => {
    const [__check] = useAxiosIndicatorCheck();
    const [status, SetStatus] = useState(false);
    const [productData, setProductData] = useState([]);
    const [alternateProductData, setAlternateProductData] = useState([]);
    const [alternateManufacturerData, setAlternateManufacturerData] = useState([]);
    const [alternateInventoryData, setAlternateInventoryData] = useState([]);
    const [alternateTypeData, setAlternateTypeData] = useState([]);
    const [{ AlternativeBomPopup }, { }, { }] = useDOMAttachToSystemStore();
    const [{ bomPricingList }, { }, { }] = useProductPricingStore();
    const pricing = bomPricingList;

    const [{ }, { get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui }, { add_part_to_bom, swap_part_number }] = useBOMStore();
    const [{ alternative_product_data }, { fetch_alternative_product_by_variant_number_list }, { clear_alternative_product_data }] = useProductStore();
    const [{ CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER }, { }, { }] = useCartStore();
    const [_check_p] = useCheckAuthPermissions();
    const [, { get_inventory_by_id }, { }] = useProductInventoryStore();
    const selected_product = AlternativeBomPopup && AlternativeBomPopup.data && AlternativeBomPopup.data.selected_product

    console.log(alternateManufacturerData)

    const getPricing = (ERPMFRPartNumber, ERPPartNumber, customerPartNumber, cpnType, ERPPartNumberModified) => {
        customerPartNumber = cpnType === Constants.cpnTypes.MANUALCPN && !customerPartNumber ? '*' : customerPartNumber
        ERPPartNumber = ERPPartNumberModified ? '' : ERPPartNumber;
        if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber + '-' + customerPartNumber]) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber + '-' + customerPartNumber];
        } else if (pricing[ERPMFRPartNumber + '-' + ERPPartNumber]) {
            return pricing[ERPMFRPartNumber + '-' + ERPPartNumber];
        }
        return [];
    };

    const getCPN = (v) => {
        return v.cpnTypeName === Constants.cpnTypes.MANUALCPN ? Helper.toUpperCase(v.manualCPN) : Helper.toUpperCase(v?.customerPartNumber)
    }

    useEffect(() => {
        SetStatus(true)
        async function fetchHere() {
            if (AlternativeBomPopup) {
                await getAlternativeProductByVariantNumber()

                setTimeout(() => {
                    $(".alternate-table").floatingScroll("init");
                }, 1000)
            }
        }

        fetchHere()
    }, [AlternativeBomPopup]);

    const onHide = (action = true) => {
        clear_alternative_product_data()
        SetStatus(false)
    };

    useEffect(() => {
        async function fetchHere() {
            await getProductData()
        }

        fetchHere()
    }, [alternative_product_data]);

    const getAlternativeProductByVariantNumber = async () => {
        await fetch_alternative_product_by_variant_number_list({ ItemNum: selected_product.itemNumber })
    }

    const onSwapHandler = async (selectedProductToSwap) => {
        const customerPartNumber = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[selectedProductToSwap?.ItemNumber]?.CUSTOMER_PART_NUMBER;
        let params = {}
        params.partNumber = selectedProductToSwap.ERPMFRPartNumber;
        params.itemNumber = selectedProductToSwap.ItemNumber;
        params.erpPartNumber = selectedProductToSwap.ERPPartNumber;
        params.manufacturerPartNumber = selectedProductToSwap.ERPMFRPartNumber;
        params.quantity = selectedProductToSwap.QtyMin
        params.LifeCycleRisk = selectedProductToSwap.LifeCycleRisk ? selectedProductToSwap.LifeCycleRisk : ''
        params.bomDetailId = selected_product.bomDetailId
        params.bomId = selected_product.bomId
        params.customerPartNumber = customerPartNumber
        params.manualCPN = selected_product.customerPartNumber ? selected_product.customerPartNumber : ''
        params.designWinFlag = selected_product?.designWinFlag
        if (params.customerPartNumber) {
            params.cpnType = Constants.cpnTypes.CPN
        } else {
            params.cpnType = Constants.cpnTypes.MANUALCPN
        }

        let swapPartRes = await swap_part_number(params)
        if (swapPartRes !== undefined &&
            swapPartRes.payload.data !== undefined) {
            await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(params.bomId)
            onHide()
        }
    }

    const onAddPartHandler = async (selectedProductToAdd) => {
        /**
         * Send ERPMFRPartNumber for used as partNumber
         * Author: Devanshi Patel
         */
        const customerPartNumber = CART_CUSTOMER_PART_NUMBER_BEFORE_TO_SEND_SERVER[selectedProductToAdd?.ItemNumber]?.CUSTOMER_PART_NUMBER;
        let params = {}
        params.ERPPartNumber = selectedProductToAdd.ERPPartNumber;
        params.partNumber = selectedProductToAdd.ERPMFRPartNumber;
        params.ManufacturerPartNumber = selectedProductToAdd.ManufacturerPartNumber;
        params.ItemNumber = selectedProductToAdd.ItemNumber;
        params.quantity = selectedProductToAdd.QtyMin
        params.LifeCycleRisk = selectedProductToAdd.LifeCycleRisk
        params.bomIds = [selected_product.bomId]
        params.fromCart = false
        params.ERPMFRPartNumber = selectedProductToAdd.ERPMFRPartNumber;
        params.customerPartNumber = customerPartNumber
        params.cpnType = params.customerPartNumber ? Constants.cpnTypes.CPN : Constants.cpnTypes.MANUALCPN
        params.manualCPN = ''

        // if (params.customerPartNumber) {
        //     params.cpnType = Constants.cpnTypes.CPN
        // } else {
        //     params.cpnType = Constants.cpnTypes.MANUALCPN
        //     params.manualCPN = ''
        // }
        let addPartRes = await add_part_to_bom(params)
        if (addPartRes !== undefined &&
            addPartRes.payload.data !== undefined) {
            await get_all_bom_detail_by_bom_id_with_type_based_on_bom_tab_ui(selected_product.bomId)
            onHide()
        }
    }

    const getProductData = async () => {

        let res = new ProductListing().toObjectWithERPPartNumber(alternative_product_data)

        let inventory = {};
        let pricing = {};
        // Auth Account Less User Restrict Pricing call
        if (validateNonLoginUser()) {
            inventory = await new ProductInventoryRepository().fetchProductInventoryByProducts(res);
        }
        else 
        {
            // DT - 13141 - 14/8/23 - Inventory and price calls are made sequentially instead of parallel
            await Promise.all([
                new ProductInventoryRepository().fetchProductInventoryByProducts(res),
                new ProductPricingRepository().fetchProductPricingByProductsNew(res)
            ]).then((resp) => {
                inventory = resp[0];
                pricing = resp[1];
            }).catch(() => { });
        }

        res = new ProductListing().attachInventoryAndPricingToProductObjectNew(res,
            {
                inventory,
                pricing
            }
        );
        let product = Helper.removeDuplicateFromObjectByItemNumber(res)
        setProductData(product)

        if (product && Object.keys(product).length > 0) {

            let alternateProductDataHere = []
            let alternateManufacturerData = []
            let alternateInventoryData = []
            let alternateTypeData = []
            Object.keys(product).map((v, i) => (
                alternateProductDataHere.push({
                    "ERPPartNumber": (product[v].ERPPartNumber !== undefined && product[v].ERPPartNumber !== null && product[v].ERPPartNumber.trim() !== '') ? product[v].ERPPartNumber : '',
                    "ItemNumber": (product[v].ItemNumber !== undefined && product[v].ItemNumber !== null && product[v].ItemNumber.trim() !== '') ? product[v].ItemNumber : '',
                    "ManufacturerPartNumber": (product[v].ManufacturerPartNumber !== undefined && product[v].ManufacturerPartNumber !== null && product[v].ManufacturerPartNumber.trim() !== '') ? product[v].ManufacturerPartNumber : '',
                    "ManufacturerDatasheetURL": Helper.valueIsNotNull(product[v].Datasheet) ? product[v].Datasheet : '#',
                    "QtyMin": (product[v].QtyMin !== undefined && product[v].QtyMin !== null && product[v].QtyMin !== '') ? product[v].QtyMin : '-',
                    "QtyMult": (product[v].QtyMult !== undefined && product[v].QtyMult !== null && product[v].QtyMult !== '') ? product[v].QtyMult : '-',
                    "LifeCycleRisk": (product[v].LifeCycleRisk !== undefined) ? product[v].LifeCycleRisk : '-',
                    "CustomerPartNumbers": (product[v].CustomerPartNumbers !== undefined && product[v].CustomerPartNumbers !== null && Array.isArray(product[v].CustomerPartNumbers) && product[v]?.CustomerPartNumbers.length > 0 ? product[v].CustomerPartNumbers : null),
                    "ERPMFRPartNumber": (product[v].ERPMFRPartNumber !== undefined && product[v].ERPMFRPartNumber !== null && product[v].ERPMFRPartNumber.trim() !== '') ? product[v].ERPMFRPartNumber : '',
                    "ManufacturerName": (product[v].ManufacturerName !== undefined && product[v].ManufacturerName !== null && product[v].ManufacturerName.trim() !== '') ? product[v].ManufacturerName : ''
                }),

                alternateManufacturerData.push({
                    "ManufacturerName": (product[v].ManufacturerName !== undefined && product[v].ManufacturerName !== null && product[v].ManufacturerName.trim() !== '') ? product[v].ManufacturerName : ''
                }),

                alternateInventoryData.push({
                    "InventoryData": (product[v].assets.inventory !== undefined) ? product[v].assets.inventory : ''
                }),

                alternateTypeData.push({
                    "Type": (product[v].Type !== undefined && product[v].Type !== null && product[v].Type.trim() !== '') ? product[v].Type : ''
                })
            ))
            setAlternateProductData(alternateProductDataHere)
            setAlternateManufacturerData(alternateManufacturerData)
            setAlternateInventoryData(alternateInventoryData)
            setAlternateTypeData(alternateTypeData)
        }
    }
    const getDisplayStatusOfCustomerPartNumber = (selected_prod, alternative) => {
        if (selected_prod !== undefined && selected_prod !== null &&
            selected_prod.product !== undefined && selected_prod.product !== null &&
            selected_prod.product.CustomerPartNumbers !== undefined && selected_prod.product.CustomerPartNumbers !== null &&
            Array.isArray(selected_prod.product.CustomerPartNumbers) &&
            selected_prod.product?.CustomerPartNumbers.length > 0) {
            return true;
        }
        if (alternative !== undefined && alternative !== null &&
            Array.isArray(alternative) &&
            alternative.filter(x => x.CustomerPartNumbers !== null).length > 0) {
            return true;
        }
        return false;
    }

    const isGuestFullRights = () => {
        return (_check_p('PDG_ADD_TO_CART').status &&
            _check_p('PDG_ADD_TO_BOM').status &&
            _check_p('PDG_CLICK_TO_QUOTE').status);
    }

    const validateNonLoginUser = () => {
        if (!liveAuth.check()) {
            return true;
        }
        return liveAuth.check() && !isGuestFullRights();
    }
    return (
        <>
            <Modal show={status} onHide={() => {
                onHide()
            }}>


                <div className="avnet-modal avnet-modal-right modal-630 bom-alternative-modal">
                    <div className="avnet-modal-inner">
                        <button type="button" className="close pt-3" data-dismiss="modal"
                            onClick={() => {
                                onHide()
                            }}>×
                        </button>
                        <div className="modal-header">
                            <h4 className="modal-title text-center" id="myModalLabel">Alternatives</h4>
                        </div>
                        <div className="modal-body">
                            <div className="copmare-product-page">
                                {
                                    productData && Object.keys(productData).length > 0 ?
                                        <>
                                            <div className="">
                                                <div className="table-responsive sticky-table-wrapper">
                                                    {
                                                        //productData && Object.keys(productData).length > 0 &&
                                                        <table
                                                            className="alternate-table copmare-product-table sticky-table table table-bordered table-striped w-auto mb-0">
                                                            <thead>
                                                                <tr>
                                                                    <th className="alternative-column-width current-selected"
                                                                        style={{ background: '#72777D' }}>CURRENTLY SELECTED
                                                                    </th>
                                                                    {alternateProductData.map((v, i) => (
                                                                        <th className="alternative-column-width">ALTERNATIVE {(i + 1)}</th>
                                                                    ))}
                                                                </tr>
                                                                <tr className="bg-white">
                                                                    <th className="alternative-column-width">
                                                                        {selected_product !== undefined &&
                                                                            <div className="compare-product-detail">
                                                                                <div className="compare-product-title">
                                                                                    <NavigateToPDP data={{
                                                                                        ManufacturerName: selected_product?.product?.ManufacturerName,
                                                                                        ERPMFRPartNumber: selected_product?.product?.ERPMFRPartNumber,
                                                                                        ItemNumber: selected_product?.product?.ItemNumber,
                                                                                    }} >
                                                                                        {selected_product.product.ERPMFRPartNumber}
                                                                                    </NavigateToPDP>
                                                                                </div>
                                                                                <div className="copmare-product-info">
                                                                                    <div className="product-img text-center">
                                                                                        <img src={selected_product.product !== undefined && selected_product.product.AssetURL && selected_product.product.AssetURL.trim() !== '' ? selected_product.product.AssetURL : noImage} />
                                                                                    </div>
                                                                                    <div className="sect-row">
                                                                                        {(selected_product.product !== undefined && selected_product.product.Datasheet) ?
                                                                                            <div className="datasheet flex-1">
                                                                                                <a className="datasheet-align img-text"
                                                                                                    rel="nofollow"
                                                                                                    href={selected_product.product.Datasheet}
                                                                                                    title={selected_product.product.ManufacturerPartNumber + " Datasheet"} target="_new">
                                                                                                    <img src={datasheet2} />
                                                                                                    Datasheet
                                                                                                </a>
                                                                                            </div>
                                                                                            :
                                                                                            ReusableDiv.dataSheetTooltip()
                                                                                        }
                                                                                        <div className="datasheet flex-1">
                                                                                            <span className="lifecycle low-risk"
                                                                                                aria-hidden="true"
                                                                                                data-toggle="tooltip"
                                                                                                data-placement="bottom"
                                                                                                data-html="true"
                                                                                                data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."
                                                                                            ><DisplayLifeCycleRisk
                                                                                                    single_product={selected_product.product}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                                <div
                                                                                    className="min-max-data text-black-stone font-normal font-10 my-2">
                                                                                    <DisplayQtyMinQtyMult
                                                                                        single_product={selected_product.product}
                                                                                    />
                                                                                </div>
                                                                                {__check(['BOM_SWAP_PART_NUMBER_API_CALL']).render}
                                                                                {!__check(['BOM_SWAP_PART_NUMBER_API_CALL']).status &&
                                                                                    <button className="bs5 btn btn-secondary w-100"
                                                                                        onClick={() => onHide()}>Keep part
                                                                                    </button>
                                                                                }
                                                                            </div>
                                                                        }
                                                                    </th>
                                                                    {alternateProductData.map((v, i) => (
                                                                        <th className="alternative-column-width" key={i}>
                                                                            <div className="compare-product-detail">
                                                                                <div className="compare-product-title">
                                                                                    <NavigateToPDP data={{
                                                                                        ManufacturerName: v.ManufacturerName,
                                                                                        ERPMFRPartNumber: v.ERPMFRPartNumber,
                                                                                        ItemNumber: v.ItemNumber,
                                                                                    }}>
                                                                                        {v.ERPMFRPartNumber}
                                                                                    </NavigateToPDP>
                                                                                </div>
                                                                                <div className="copmare-product-info">
                                                                                    <div className="product-img text-center">
                                                                                        <img src={v.AssetURL !== undefined && v.AssetURL !== null && v.AssetURL.trim() !== '' ? v.AssetURL : noImage} />
                                                                                    </div>
                                                                                    <div className="sect-row">
                                                                                        {v.ManufacturerDatasheetURL !== null && v.ManufacturerDatasheetURL !== undefined && v.ManufacturerDatasheetURL !== '' &&
                                                                                            <div className="datasheet flex-1">
                                                                                                <a className="datasheet-align img-text"
                                                                                                    rel="nofollow"
                                                                                                    href={v.ManufacturerDatasheetURL}
                                                                                                    title={v.ManufacturerPartNumber + " Datasheet"} target="_new">
                                                                                                    <img src={datasheet2} />
                                                                                                    <span className="blue text">
                                                                                                        Datasheet
                                                                                                    </span>
                                                                                                </a>
                                                                                            </div>
                                                                                        }
                                                                                        <div className="datasheet flex-1">
                                                                                            <span className="lifecycle low-risk"
                                                                                                aria-hidden="true"
                                                                                                data-toggle="tooltip"
                                                                                                data-placement="bottom"
                                                                                                data-html="true"
                                                                                                data-title="LOW RISK:<br/>Part listed as active by Manufacturer. Suitable for new and existing designs."
                                                                                            ><DisplayLifeCycleRisk
                                                                                                    single_product={v}
                                                                                                />
                                                                                            </span>
                                                                                        </div>
                                                                                    </div>

                                                                                </div>
                                                                                <div
                                                                                    className="min-max-data text-black-stone font-normal font-10 my-2">
                                                                                    <DisplayQtyMinQtyMult
                                                                                        single_product={v}
                                                                                    />
                                                                                </div>
                                                                                <div className='bs5 row g10'>
                                                                                    <div className='col-6'>
                                                                                        {__check(['BOM_SWAP_PART_NUMBER_API_CALL']).render}
                                                                                        {!__check(['BOM_SWAP_PART_NUMBER_API_CALL']).status &&
                                                                                            <button className="bs5 btn btn-primary w-100"
                                                                                                onClick={() => onSwapHandler(v)}>swap
                                                                                            </button>
                                                                                        }
                                                                                    </div>
                                                                                    <div className='col-6'>
                                                                                        {__check(['BOM_SWAP_PART_NUMBER_API_CALL']).render}
                                                                                        {!__check(['BOM_SWAP_PART_NUMBER_API_CALL']).status &&
                                                                                            <button className="bs5 btn btn-secondary w-100"
                                                                                                onClick={() => onAddPartHandler(v)}>Add
                                                                                            </button>
                                                                                        }
                                                                                    </div>
                                                                                </div>


                                                                            </div>
                                                                        </th>
                                                                    ))}
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={0}><b>Manufacturer</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td className="alternative-column-width">
                                                                        {selected_product !== undefined && selected_product.product &&
                                                                            selected_product.product.ManufacturerName
                                                                        }
                                                                    </td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td key={i}>{v.ManufacturerName}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={0}><b>Availability</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td className="alternative-column-width">
                                                                        {selected_product && <ProductInventoryDisplay single_product={selected_product} isFrom={Constants.isFrom.BOM_ALT_POPUP} single_product_inventory={get_inventory_by_id(selected_product?.ERPPartNumber)} />}
                                                                    </td>
                                                                    {alternateInventoryData.map((v, i) => (
                                                                        <td className="alternative-column-width" key={i}>
                                                                            {selected_product && <ProductInventoryDisplay single_product={v} isFrom={Constants.isFrom.BOM_ALT_POPUP} single_product_inventory={get_inventory_by_id(v?.ERPPartNumber)} />}
                                                                        </td>
                                                                    ))}
                                                                </tr>
                                                                <tr className={getDisplayStatusOfCustomerPartNumber(selected_product, alternateProductData) === true ? '' : ' d-none'}>
                                                                    <td colSpan={0}><b>Customer Part Number</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr className={getDisplayStatusOfCustomerPartNumber(selected_product, alternateProductData) === true ? "compared-product-price" : "compared-product-price d-none"}>
                                                                    <td className="alternative-column-width">
                                                                        {selected_product !== undefined && selected_product.product !== undefined && selected_product.product.assets &&
                                                                            <CustomerPartNumberOptions
                                                                                single_product_pricing_list={selected_product.product.assets.pricing}
                                                                                single_product_inventory={selected_product.product.assets.inventory}
                                                                                single_product={selected_product.product} />
                                                                        }
                                                                    </td>
                                                                    {
                                                                        Object.keys(productData).map((v, i) => (
                                                                            <td key={v} className="alternative-column-width">
                                                                                <CustomerPartNumberOptions
                                                                                    single_product_pricing_list={productData[v].assets.pricing}
                                                                                    single_product_inventory={productData[v].assets.inventory}
                                                                                    single_product={productData[v]} />
                                                                            </td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={0}><b>Price</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr className="compared-product-price">
                                                                    <td className="alternative-column-width">
                                                                        {selected_product !== undefined && selected_product.product !== undefined &&
                                                                            <PriceTable
                                                                                isDisplayCPN={false}
                                                                                single_product_inventory={get_inventory_by_id(selected_product?.product?.ERPPartNumber)}
                                                                                single_product={selected_product?.product}
                                                                                single_product_pricing_list={getPricing(selected_product?.product?.ERPMFRPartNumber, selected_product.product.ERPPartNumber, getCPN(selected_product), selected_product.cpnTypeName, selected_product.ERPPartNumberModified)}
                                                                            />
                                                                        }
                                                                    </td>
                                                                    {
                                                                        Object.keys(productData).map((v, i) => (
                                                                            <td key={v} className="alternative-column-width">
                                                                                <PriceTable
                                                                                    isDisplayCPN={false}
                                                                                    force_display_pricing_table={'yes'}
                                                                                    single_product_pricing_list={productData[v].assets.pricing}
                                                                                    single_product_inventory={productData[v].assets.inventory}
                                                                                    single_product={productData[v]}
                                                                                />
                                                                            </td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={0}><b>Mounting</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td className="alternative-column-width">Through Hole</td>
                                                                    {alternateManufacturerData.map((v, i) => (
                                                                        <td>Through Hole</td>
                                                                    ))}
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={0}><b>Type</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td className="alternative-column-width">
                                                                        {
                                                                            selected_product !== undefined && selected_product.product.Type
                                                                        }
                                                                    </td>
                                                                    {
                                                                        alternateTypeData.map((v, i) => (
                                                                            <td key={i}>{v.Type}</td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={0}><b>Pin Count</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td className="alternative-column-width">10</td>
                                                                    {alternateManufacturerData.map((v, i) => (
                                                                        <td>10</td>
                                                                    ))}
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={0}><b>Viewing Area Length</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td className="alternative-column-width">7.8 mm</td>
                                                                    {alternateManufacturerData.map((v, i) => (
                                                                        <td>7.8 mm</td>
                                                                    ))}
                                                                </tr>
                                                                <tr>
                                                                    <td colSpan={0}><b>Viewing Area Height</b></td>
                                                                    {
                                                                        alternateManufacturerData.map((v, i) => (
                                                                            <td></td>
                                                                        ))
                                                                    }
                                                                </tr>
                                                                <tr>
                                                                    <td className="alternative-column-width">14.22 mm</td>
                                                                    {alternateManufacturerData.map((v, i) => (
                                                                        <td>14.22 mm</td>
                                                                    ))}
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    }
                                                </div>
                                            </div>
                                        </>
                                        :
                                        <AxiosIndicatorRunTimeLoader />
                                }
                            </div>
                        </div>

                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AlternativeBomPopup;